const Country = {

    // FIELDS
    "name": "اسم",
    "status": "الحالة",
    "search": "البحث",

    // PAGE HEADER
    "country": "الدولة",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_status": "يرجى تحديد الحالة",

    // TABLE HEADERF
    "table_name": "الاسم",
    "table_status": "الحالة",

}

export default Country;